import PinkStroke1 from '../../assets/images/pink-stroke-1.svg';
import PinkStroke2 from '../../assets/images/pink-stroke-2.svg';
import PinkStroke3 from '../../assets/images/pink-stroke-3.svg';
import BlueBlobMobile from '../../assets/images/mobile/blue-blob.png';
import GreenCircle from '../../assets/images/backgrounds/intro/green-circle.png';
import IntroCrayon from '../../assets/images/intro-crayon.svg';
import { Button } from '../shared/Button';
import { linkTo } from '../Results/utils';

export function SurveyIntro({
  onNextClick
}: {
  onNextClick: () => void;
}) {
  return (
    <main id="main-content" role="main" className="flex flex-col items-center gap-6 w-full md:mt-6 md:w-[600px] lg:w-[850px] md:pb-8">
      <p className="text-xl px-4 md:hidden">
        After completing this survey, you will receive a customized summary of your creative style.<br/><br/>
        <span className="font-semibold text-crayola-blue">The Crayola Creative Style Tool</span> is not a test. Rather, it is designed to organize the dimensions of creative thinking into a profile that represents your unique approach to the creative process.
      </p>
      <p className="text-crayola-blue px-4 hidden md:block md:px-0 text-2xl font-semibold md:text-center">Today creative thinking is widely recognized as an essential life skill. Given its importance, Crayola is dedicated to supporting creativity in all people.</p>
      <p className="text-xl px-4 hidden md:block md:px-0">
        Crayola defines creativity as “imagination in action.” There are many ways we can nurture creativity in ourselves, colleagues, and the children around us so that each individual flourishes and reaches full potential.<br/><br/>
        As such, Crayola has developed this tool and the personalized profiles that you’ll receive after completing this survey to help you identify the diverse ways in which creative thinking is expressed based on our personal preferences. This tool helps individuals recognize and celebrate their own creative-thinking preferences and builds appreciation for the diversity of thought around us.<br/><br/>
        The <span className="font-semibold text-crayola-blue">Crayola Creative Style Tool</span> is not a test. Rather, it is designed to take the many dimensions of creative thinking and organize them into a profile that represents an individual’s unique approach to the creative process. The ultimate objective of this self-reflection tool is to help people gain an understanding of the diverse ways in which people behave creatively.
      </p>
      <span className="font-semibold px-4 hidden md:block md:px-0 text-xl text-crayola-pink italic md:text-center w-full md:w-[600px] lg:w-[850px]">What follows are a series of word pairs that represent different dimensions of creativity.</span>
      <div className="flex flex-col items-center gap-0 md:flex-row text-crayola-blue italic md:gap-2 relative">
        <img alt="" className="absolute -right-[300px] bottom-4 md:-right-[340px] md:-bottom-0" src={IntroCrayon} />
        <div className="flex gap-2">
          <div className="flex flex-col items-center">
            <span className="text-[46px] font-semibold">Think,</span>
            <img alt="" src={PinkStroke1} className="relative bottom-2 md:bottom-0"/>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-[46px] font-semibold">Perceive,</span>
            <img alt="" src={PinkStroke2} className="relative bottom-2 md:bottom-0"/>
          </div>
        </div>
        <div className="flex gap-2 relative bottom-3 md:bottom-0">
          <span className="text-[50px] font-regular relative bottom-1">and</span>
          <div className="flex flex-col items-center">
            <span className="text-[46px] font-semibold">Engage.</span>
            <img alt="" src={PinkStroke3} className="relative bottom-2 md:bottom-0"/>
          </div>
        </div>
      </div>
      <div className="button-row flex justify-center gap-8 mt-8">
        <Button
          role="link"
          rightArrow
          onClick={() => linkTo('https://www.crayola.com/CreativeStyles')}
          type="outline"
          text="BACK"
        />
        <Button
          role="link"
          type="solid"
          rightArrow
          onClick={onNextClick}
          text="NEXT"
        />
      </div>
      <div className="w-full md:hidden relative">
        <img alt="" src={BlueBlobMobile} className="w-full" />
        <img alt="" src={GreenCircle} className="w-16 h-16 absolute top-16 left-24" />
      </div>
    </main>
  )
}